(function () {
  var imageMap = [
    {
      selector: '.pnc-hero__media > img',
      url: 'https://cdn.shopify.com/s/files/1/0674/9916/3744/files/patitas-hero-perro-premios-premium-v2.png?v=1785954190',
      widths: [480, 720, 1100, 1536],
      sizes: '(max-width: 720px) calc(100vw - 32px), (max-width: 1100px) calc(100vw - 48px), 52vw',
      alt: 'Perro feliz con premios naturales Patitas Natural Club',
      priority: true
    },
    {
      selector: '.pnc-category-card:nth-child(1) .pnc-category-card__media img',
      url: 'https://cdn.shopify.com/s/files/1/0674/9916/3744/files/patitas-premios-vital-bites-hd.png?v=1785950136',
      widths: [480, 800, 1200, 1448],
      sizes: '(max-width: 900px) 38vw, 15vw',
      alt: 'Premios naturales Patitas con perro'
    },
    {
      selector: '.pnc-category-card:nth-child(2) .pnc-category-card__media img',
      url: 'https://cdn.shopify.com/s/files/1/0674/9916/3744/files/patitas-juguetes-perro-jugando-hd.png?v=1785950160',
      widths: [480, 800, 1200, 1448],
      sizes: '(max-width: 900px) 38vw, 15vw',
      alt: 'Perro jugando con cuerda y pelota'
    },
    {
      selector: '.pnc-category-card:nth-child(3) .pnc-category-card__media img',
      url: 'https://cdn.shopify.com/s/files/1/0674/9916/3744/files/patitas-natural-club-caja-hd.png?v=1785950177',
      widths: [480, 800, 1200, 1448],
      sizes: '(max-width: 900px) 38vw, 15vw',
      alt: 'Caja Patitas Natural Club con perro feliz'
    },
    {
      selector: '.pnc-match-section__media img',
      url: 'https://cdn.shopify.com/s/files/1/0674/9916/3744/files/patitas-como-elegimos-perro-premio-hd.png?v=1785950194',
      widths: [640, 960, 1200, 1448],
      sizes: '(max-width: 900px) calc(100vw - 32px), 48vw',
      alt: 'Golden retriever recibiendo un premio natural'
    },
    {
      selector: '.pnc-instagram-section__media img',
      url: 'https://cdn.shopify.com/s/files/1/0674/9916/3744/files/patitas-natural-club-caja-hd.png?v=1785950177',
      widths: [640, 960, 1200, 1448],
      sizes: '(max-width: 900px) calc(100vw - 32px), 55vw',
      alt: 'Caja Patitas Natural Club con productos Patitas y perro feliz'
    }
  ];

  function shopifyWidthUrl(url, width) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function applyHighResolutionImages() {
    imageMap.forEach(function (item) {
      var image = document.querySelector(item.selector);
      if (!image) return;
      image.src = shopifyWidthUrl(item.url, item.widths[item.widths.length - 1]);
      image.srcset = item.widths.map(function (width) {
        return shopifyWidthUrl(item.url, width) + ' ' + width + 'w';
      }).join(', ');
      image.sizes = item.sizes;
      image.alt = item.alt;
      image.decoding = 'async';
      image.removeAttribute('width');
      image.removeAttribute('height');
      if (item.priority) {
        image.loading = 'eager';
        image.fetchPriority = 'high';
      } else {
        image.loading = 'lazy';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHighResolutionImages, { once: true });
  } else {
    applyHighResolutionImages();
  }
})();
